import { createSelector, createStructuredSelector } from 'reselect';

export const getChannels = (state) => state.channels;

export const channelsMapSelector = createSelector(
  getChannels,
  (channels) => channels.channelsMap
);

export const currentChannelSelector = createSelector(
  getChannels,
  (channels) => channels.currentChannel
);

export const channelsByGenresSelector = createSelector(
  getChannels,
  (channels) => channels.channelsByGenres
);

export const currentChannelAbsoluteIdSelector = createSelector(
  getChannels,
  (channels) => channels.currentChannelAbsoluteId
);

export const subscriptionInfoMapSelector = createSelector(
  getChannels,
  (channels) => channels.subscriptionInfoMap
);

export default createStructuredSelector({
  channelsMapSelector,
  currentChannelSelector,
  channelsByGenresSelector,
  currentChannelAbsoluteIdSelector,
  subscriptionInfoMapSelector,
});
